import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { fadeInRight400ms } from 'src/@vex/animations/fade-in-right.animation';
import { fadeInUp400ms } from 'src/@vex/animations/fade-in-up.animation';
import { scaleIn400ms } from 'src/@vex/animations/scale-in.animation';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';

export function ConfirmPasswordValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    let control = formGroup.controls[controlName];
    let matchingControl = formGroup.controls[matchingControlName]
    if (
      matchingControl.errors &&
      !matchingControl.errors.confirmPasswordValidator
    ) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmPasswordValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

@Component({
  selector: 'vex-admin-reset-password',
  templateUrl: './admin-reset-password.component.html',
  styleUrls: ['./admin-reset-password.component.scss'],
  animations: [
    fadeInUp400ms,
    fadeInRight400ms,
    scaleIn400ms
  ]
})
export class AdminResetPasswordComponent implements OnInit {
  form: FormGroup
  visible = false;
  inputType = 'password';

  constructor(private fb: FormBuilder, public guiService: GuiService, public restService: RestService,  private cd: ChangeDetectorRef, public translate: TranslateService) { }

  ngOnInit(): void {

    this.form = this.fb.group({
      password:['', [Validators.required]],
      confirmPassword: ['', [Validators.required]]
    },{
      validator: ConfirmPasswordValidator("password", "confirmPassword")
    })
  }


  send(){
    let editPassword = {
      password: this.form.value.password
    }
    this.restService.putService('users','', editPassword).subscribe((ris)=>{
      this.guiService.openSnackBar(this.translate.instant('GLOBAL.EDIT_SUCCESS'), 'ok!')
      })
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }

}
